<template>
    <div class="results-container">
        <div class="results-header">
            <h1>Results</h1>
        </div>
        <div class="results-body">
            <div class="options-container">
                <div class="control">
                    <p>Please choose a date:</p>
                    <div class="select dates">
                        <div class="select-wrapper">
                            <select class="day-select" v-model="currentDay" @change="setNamesIDs()">
                                <option v-for="day in days" :key="day" :value="day">{{ day }}</option>
                            </select>
                        </div>
                        <div class="select-wrapper">
                            <select class="month-select" v-model="currentMonth" @change="setDays(); setNamesIDs();">
                                <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
                            </select>
                        </div>
                        <div class="select-wrapper">
                            <select class="year-select" v-model="currentYear" @change="setNamesIDs()" disabled>
                                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="control">
                    <p>Please choose a sport:</p>
                    <div class="select sport-select">
                        <div class="select-wrapper">
                            <select v-model="currentSport" @change="setNamesIDs()">
                                <option v-for="(result, key) in menuData.categories" :key="key" :value="key">{{ formatSport(key) }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="control">
                    <p>Please choose a meeting:</p>
                    <div class="select meeting-select">
                        <div class="select-wrapper">
                            <select v-model="currentMeeting" @change="setCurrentMeeting(currentMeeting)" v-if="hasEvents && currentResults[getCurrentDateString()].categories[currentSport]">
                                <option v-for="(result, key) in currentResults[getCurrentDateString()].categories[currentSport].events" :key="key" :value="key">{{ result['name'] }}</option>
                            </select>
                            <select v-else>
                                <option>No meetings available</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="control">
                    <p>Please choose an event:</p>
                    <div class="select event-select">
                        <div class="select-wrapper">
                            <select v-model="currentEvent" @change="setCurrentEvent(currentEvent)" v-if="hasEvents && currentResults[getCurrentDateString()].categories[currentSport].events[currentMeeting]">
                                <option v-for="result in currentResults[getCurrentDateString()].categories[currentSport].events[currentMeeting].events" :key="result.ID" :value="result.ID">{{ result['name'] }}</option>
                            </select>
                            <select v-else>
                                <option>No events available</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="results-tables">
                <div class="event-container solo">
                    <div v-if="Object.keys(currentEventData).length == 0">
                        <div class="event-body no-data">
                            <p>There is currently no data available for this event</p>
                        </div>
                    </div>
                    <div v-else>
                        <div class="event-header">
                            <h2>{{ currentEventData.name }}</h2>
                            <span class="event-start-time">{{ currentEventData.startTime }}</span>
                            <p>{{ currentEventData.eachWay }}</p>
                        </div>
                        <div class="event-body">
                            <table class="table" :class="{ 'is-bordered' : isBordered, 'is-striped' : isStriped, 'is-narrow' : isNarrow, 'is-hoverable' : isHoverable, 'is-fullwidth' : isFullwidth }">
                                <thead>
                                    <tr>
                                        <th>Pos.</th>
                                        <th>No.</th>
                                        <th>Selection</th>
                                        <th>Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="selection in currentEventData.selections" :key="selection.name">
                                        <td class="selection-position">
                                            {{ selection.position }}
                                        </td>
                                        <td class="selection-number">
                                            {{ selection.number }}
                                        </td>
                                        <td>
                                            <div class="selection-name-details">
                                                <strong class="selection-name"><img class="selection-colour" :src="getColours(selection.silks)"> {{ selection.name }}</strong>
                                                <span class="selection-details" v-if="selection.jockey != undefined && selection.jockey != ''">J: {{ selection.jockey }}</span>
                                            </div>
                                        </td>
                                        <td class="price">
                                            <span>
                                                {{ selection.price }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr class="fc-tc-row" v-if="currentEventData.forecast != '' || currentEventData.tricast != ''">
                                        <td colspan="4">
                                            <span v-if="currentEventData.forecast != ''"><strong>Forecast:</strong> {{ currentEventData.forecast }} </span><span v-if="currentEventData.tricast != ''"><strong>Tricast:</strong></span> {{ currentEventData.tricast }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from '../main';

export default {
    props: [ 'results', 'menuData' ],
    data() {
        return {
            currentResults: {},
            currentEventData: {},
            dates: [],
            currentDay: this.getCurrentDate().day,
            currentMonth: this.getCurrentDate().month,
            currentYear: this.getCurrentDate().year,
            days: 31,
            months: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ],
            years: [
                parseInt(this.getCurrentDate()['year'])
            ],
            currentSport: 'vip-horse',
            currentMeeting: '',
            currentEvent: '',
            isBordered: true,
            isStriped: true,
            isNarrow: false,
            isHoverable: true,
            isFullwidth: false,
            isLoading: false,
            hasEvents: false
        }
    },
    computed: {
        getMeeting() {
            if(typeof this.currentResults[this.getCurrentDateString()] == 'undefined') {
                meeting = 'No meetings available';
                return meeting;
            }

            let meeting = this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[this.currentMeeting];

            if(typeof meeting == 'undefined') {
                meeting = 'No meetings available';
            }

            return meeting;
        },
        monthDays() {
            var _self = this;
            var days = 31;

            this.months.forEach((month) => {
                if(month.name == _self.month) {
                    if(month.name == 'Feb') {
                        days = _self.getFebDays;
                    } else {
                        days = month.days;
                    }
                }
            });

            return days;
        },
        getFebDays() {
            var days = 28;
            var isLeap = new Date(this.year, 1, 29).getMonth() == 1;

            if(isLeap) days = 29;

            return days;
        },
        currentSportName() {
            return this.formatSport(this.currentSport);
        },
        currentMeetingName() {
            return this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[this.currentMeeting].name;
        }
    },
    mounted() {
        this.setNamesIDs();
        this.setDates();
    },
    methods: {
        getEachWay(reduction, placeTerms) {
            if(reduction == 1 && placeTerms == 1) {
                return 'Win only';
            }

            var red = '1/' + reduction;

            var place = placeTerms;

            for(let i = place - 1; i > 0; i--) {
                place = i + '-' + place;
            }

            return 'Each way ' + red + ' odds ' + place;
        },
        setCurrentEventData() {
            if(
                typeof this.currentResults[this.getCurrentDateString()] == 'undefined'
                || typeof this.currentResults[this.getCurrentDateString()].categories[this.currentSport] == 'undefined'
                || typeof this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[this.currentMeeting] == 'undefined'
            ) {
                this.currentEventData = {};
                return;
            }

            var ev = {};

            this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[this.currentMeeting].events.forEach((event) => {
                if(event.ID == this.currentEvent) {
                    ev = event;
                }
            });

            this.currentEventData = ev;
        },
        getCurrentDateString() {
            return this.currentYear + '-' + this.getNumericalMonth() + '-' + this.currentDay;
        },
        noEvents() {
            if(typeof this.currentResults[this.getCurrentDateString()] == 'undefined') {
                this.hasEvents = false;
                return true;
            }

            if(typeof this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events == 'undefined' || Object.keys(this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events).length === 0) {
                this.hasEvents = false;
                return true;
            }

            var hasLength = false;

            for(let key in this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events) {
                let meeting = this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[key];
                
                if(meeting.events.length > 0) hasLength = true;
            }

            this.hasEvents = hasLength;

            return !hasLength;
        },
        formatSport(str, appendRacing = true) {
            let tmp = str.replace(/-/g, ' ');
            tmp = tmp.replace(/_/g, '/');
            tmp = tmp.split(' ');
            tmp.forEach((item, ind) => {
                if(item == 'vip') {
                    tmp[ind] = item.toUpperCase();
                } else {
                    tmp[ind] = item.charAt(0).toUpperCase() + item.slice(1);
                }
            });
            tmp = tmp.join(' ');

            if(str == 'vip-horse' && appendRacing == true) {
                tmp += ' Racing';
            }

            if(str == 'vip-greyhound' && appendRacing == true) {
                tmp += 's';
            }

            return tmp;
        },
        getCurrentDate() {
            var options = {month: 'long'};
            
            var date = new Date();

            var day = date.getDate();
            var month = new Intl.DateTimeFormat('en-GB', options);
            month = month.format(date);
            month = month.replace(/[^ -~]/g,'');
            month = month.trim();
            month = month.slice(0,3);
            var year = date.getFullYear();

            return {
                'day': day,
                'month': month,
                'year': year
            };
        },
        setDates() {
            var options = {month: 'long'};

            let date = new Date();
            var earliest = new Date(date.setDate(date.getDate() - 60));
            var earliestYear = earliest.getFullYear();
            var earliestMonth = earliest.getMonth();
            var earliestDay = earliest.getDate();
            var dates = [earliest];

            date = new Date();
            date.setDate(date.getDate() - 1);   // Today's date

            while(dates[dates.length - 1] < date) {
                dates.push(new Date(earliestYear, earliestMonth, ++earliestDay));
            }

            this.dates = dates;

            var months = [];
            var years = [];

            dates.forEach((date) => {
                let month = new Intl.DateTimeFormat('en-GB', options);
                month = month.format(date);
                month = month.replace(/[^ -~]/g,'');
                month = month.trim();
                month = month.slice(0,3);
                if(months.indexOf(month) < 0) months.push(month);

                let year = date.getFullYear();
                if(years.indexOf(year) < 0) years.push(year);
            });

            this.months = months;
            this.years = years;

            this.setDays();
        },
        setDays() {
            var days = [];
            var month = 0;
            var start = 1;
            var end = 31;
            var date = new Date();

            month = this.getNumericalMonth();

            if(this.currentMonth == this.months[0]) {
                // This is the first month, so there will be fewer days
                start = this.dates[0].getDate();
                end = new Date(this.currentYear, month, 0).getDate();
            } else if(this.currentMonth == this.months[this.months.length - 1]) {
                // This is the last month, so there will be fewer days
                start = 1;
                end = new Date().getDate();
            } else {
                // This is a full month
                start = 1;
                end = new Date(this.currentYear, month, 0).getDate();
            }

            for(let i = start; i <= end; i++) {
                days.push(i);
            }

            if(this.months.indexOf('Jan') > -1 && this.months.indexOf('Dec') > -1) {
                // The dates span multiple years, set correct year when changing month
                if(this.currentMonth == 'Oct' || this.currentMonth == 'Nov' || this.currentMonth == 'Dec') {
                    if(this.currentYear == date.getFullYear()) {
                        this.currentYear = new Date(date.setFullYear(date.getFullYear() - 1)).getFullYear();
                    }
                } else if(this.currentMonth == 'Jan' || this.currentMonth == 'Feb' || this.currentMonth == 'Mar') {
                    if(this.currentYear < date.getFullYear()) {
                        this.currentYear = date.getFullYear();
                    }
                }
            }

            this.days = days;

            if(this.currentDay > end) this.currentDay = end;
            if(this.currentDay < start) this.currentDay = start;
        },
        getColours(index) {
            let toUse = '';
            let prefix = '';
            let error = false;

            switch(this.currentSport) {
                case 'vip-horse':
                    toUse = 'horses';
                    prefix = 'H';
                    break;
                case 'vip-greyhound':
                    toUse = 'greyhounds';
                    prefix = 'G';
                    break;
                case 'vip-cycling':
                    toUse = 'cycling';
                    prefix = 'C';
                    break;
                case 'vip-motor-racing':
                    toUse = 'motorracing';
                    prefix = 'M';
                    break;
                case 'vip-speedway':
                    toUse = 'speedway';
                    prefix = 'S';
                    break;
                default:
                    error = true;
                    break;
            }

            if(error) {
                console.error('Error getting silks');
                return false;
            }

            try {
                var pathToImg = require('../assets/img/colours/' + toUse + '/VIP' + prefix + index + '.png');
            } catch(e) {
                var pathToImg = '';
            }

            return pathToImg;
        },
        setNamesIDs() {
            if(!this.currentResults[this.getCurrentDateString()]) {
                this.currentResults[this.getCurrentDateString()] = {
                    'categories': {
                        'vip-horse': {
                            'name': 'VIP Horse Racing',
                            'events': {}
                        },
                        'vip-greyhound': {
                            'name': 'VIP Greyhounds',
                            'events': {}
                        },
                        'vip-cycling':{
                            'name': 'VIP Cycling',
                            'events': {}
                        },
                        'vip-motor-racing': {
                            'name': 'VIP Motor Racing',
                            'events': {}
                        },
                        'vip-speedway': {
                            'name': 'VIP Speedway',
                            'events': {}
                        }
                    }
                };
            }

            var _self = this;
            
            eventBus.$emit('loading', ['Results', true]);

            // Add leading 0 to appropriate days
            let day = this.currentDay;
            if(day < 10) {
                day = '0' + day;
            }
            
            let date = day + '/' + this.getNumericalMonth(true) + '/' + this.currentYear;
            let cacheDate = this.currentYear + '-' + this.getNumericalMonth(true) + '-' + day;
            let sport = this.formatSport(this.currentSport, false);

            this.$API.GetResults(date, cacheDate, sport, true, (response) => {
                let res = response.result;
                let tmpEvents = [];
                if(response.status == 0 || res.errors) {
                    console.error(res.errors);
                    eventBus.$emit('loading', ['Results', false]);
                    return;
                }

                res.forEach((event) => {
                    var tmp = {
                        'ID': event.ID,
                        'name': event.name,
                        'category': _self.currentSport,
                        'meetingID': event.meetingID,
                        'meetingName': event.meetingName
                    };

                    tmpEvents.push(tmp);
                });

                tmpEvents.sort(this.compareEvents);

                tmpEvents.forEach((event) => {
                    var found = false;
                    let currentTime = _self.getCurrentDateString(); // Use this in future
                    if(typeof _self.currentResults[_self.getCurrentDateString()] == 'undefined') {
                        _self.currentResults[_self.getCurrentDateString()] = {};
                    }

                    if(typeof _self.currentResults[_self.getCurrentDateString()].categories == 'undefined') {
                        _self.currentResults[_self.getCurrentDateString()].categories = {};
                    }

                    if(typeof _self.currentResults[_self.getCurrentDateString()].categories[this.currentSport] == 'undefined') {
                        _self.currentResults[_self.getCurrentDateString()].categories[this.currentSport] = {};
                    }

                    if(typeof _self.currentResults[_self.getCurrentDateString()].categories[this.currentSport].events == 'undefined') {
                        _self.currentResults[_self.getCurrentDateString()].categories[this.currentSport].events = {};
                    }

                    for(let key in _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events) {
                        let meeting = _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[key];

                        meeting.events.forEach((meetingEvent, index) => {
                            if(meetingEvent.ID == event.ID) {
                                found = true;
                                let tmpEv = _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[key].events[index];

                                // Set keys one at a time so only new values are overwritten
                                for(let k in tmpEv) {
                                    _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[key].events[index][k] = event[k];
                                }
                            }
                        });
                    }

                    if(!found) {
                        if(typeof _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[event.meetingID] == 'undefined') {
                            _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[event.meetingID] = {
                                'name': event.meetingName,
                                'events': []
                            };
                        }

                        _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[event.meetingID].events.push(event);
                    }
                });

                let meeting = Object.keys(this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events)[0];

                this.noEvents();
                this.setCurrentEventData();
                this.setCurrentMeeting(meeting);

                eventBus.$emit('loading', ['Results', false]);
            });
        },
        setCurrentResults() {
            if(!this.currentResults[this.getCurrentDateString()]) {
                this.currentResults[this.getCurrentDateString()] = {
                    'categories': {
                        'vip-horse': {
                            'name': 'VIP Horse Racing',
                            'events': {}
                        },
                        'vip-greyhound': {
                            'name': 'VIP Greyhounds',
                            'events': {}
                        },
                        'vip-cycling':{
                            'name': 'VIP Cycling',
                            'events': {}
                        },
                        'vip-motor-racing': {
                            'name': 'VIP Motor Racing',
                            'events': {}
                        },
                        'vip-speedway': {
                            'name': 'VIP Speedway',
                            'events': {}
                        }
                    }
                }
            }
            
            var _self = this;
            var results = [];
            var tmp = [];

            eventBus.$emit('loading', ['Results', true]);

            let date = this.currentDay + '/' + this.getNumericalMonth(true) + '/' + this.currentYear;
            let cacheDate = this.currentYear + '-' + this.getNumericalMonth(true) + '-' + this.currentDay;
            let sport = this.formatSport(this.currentSport, false);

            this.$API.GetResults(date, cacheDate, sport, false, (response) => {
                let res = response.result;
                let tmpEvents = [];

                if(response.status == 0 || res.errors) {
                    console.error(res.errors);
                    eventBus.$emit('loading', ['Results', false]);
                    return;
                }

                res.forEach((event) => {
                    let eachWay = this.getEachWay(event.EWReduction, event.EWPlaceTerms);

                    var tmp = {
                        'ID': event.ID,
                        'name': event.name,
                        'category': _self.currentSport,
                        'meetingID': event.meetingID,
                        'meetingName': event.meetingName,
                        'startTime': event.startTime,
                        'eachWay': eachWay,
                        'selections': []
                    };

                    let selections = event.selections;

                    selections.forEach((selection) => {
                        let tmpSel = {
                            'position': selection.position,
                            'number': selection.number,
                            'name': selection.name,
                            'jockey': selection.jockey,
                            'silks': selection.silks
                        };

                        tmp.selections.push(tmpSel);
                    });

                    tmp.selections.sort(this.compareSelections);

                    tmpEvents.push(tmp);
                });

                tmpEvents.sort(this.compareEvents);

                tmpEvents.forEach((event) => {
                    var found = false;

                    if(typeof _self.currentResults[_self.getCurrentDateString()] == 'undefined') {
                        _self.currentResults[_self.getCurrentDateString()] = {};
                    }

                    if(typeof _self.currentResults[_self.getCurrentDateString()].categories == 'undefined') {
                        _self.currentResults[_self.getCurrentDateString()].categories = {};
                    }

                    if(typeof _self.currentResults[_self.getCurrentDateString()].categories[this.currentSport] == 'undefined') {
                        _self.currentResults[_self.getCurrentDateString()].categories[this.currentSport] = {};
                    }

                    if(typeof _self.currentResults[_self.getCurrentDateString()].categories[this.currentSport].events == 'undefined') {
                        _self.currentResults[_self.getCurrentDateString()].categories[this.currentSport].events = {};
                    }

                    for(let key in _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events) {
                        let meeting = _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[key];

                        meeting.events.forEach((meetingEvent, index) => {
                            if(meetingEvent.ID == event.ID) {
                                found = true;
                                _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[key].events[index] = event;
                            }
                        });
                    }

                    if(!found) {
                        if(typeof _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[event.meetingID] == 'undefined') {
                            _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[event.meetingID] = {
                                'name': event.meetingName,
                                'events': []
                            };
                        }

                        _self.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[event.meetingID].events.push(event);
                    }
                });

                let meeting = Object.keys(this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events)[0];
                let event = this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[meeting].events[0].ID;

                this.noEvents();
                this.setCurrentEventData();
                this.setCurrentMeeting(meeting);
                this.setCurrentEvent(event);

                eventBus.$emit('loading', ['Results', false]);
            });
        },
        compareEvents(a, b) {
			if(a.name < b.name) return -1;
			if(a.name > b.name) return 1;
			return 0;
        },
        compareSelections(a, b) {
            if(parseInt(a.position) < parseInt(b.position)) return -1;
            if(parseInt(a.position) > parseInt(b.position)) return 1;
            return 0;
        },
        formatStartDate(str) {
            if(str == '') return false;
            var tmp = str.split(' ');
            var day = tmp[0];
            var month = tmp[1];
            var year = tmp[2];

            day = day.replace(/[^0-9]./, '');
            year = '20' + year;

            return {
                'day': day,
                'month' : month,
                'year': year
            };
        },
        getNumericalMonth(leadingZero = false) {
            let month = ((leadingZero == true) ? '01' : 1);

            switch(this.currentMonth) {
                case 'Jan':
                    month = ((leadingZero == true) ? '01' : 1);
                    break;
                case 'Feb':
                    month = ((leadingZero == true) ? '02' : 2);
                    break;
                case 'Mar':
                    month = ((leadingZero == true) ? '03' : 3);
                    break;
                case 'Apr':
                    month = ((leadingZero == true) ? '04' : 4);
                    break;
                case 'May':
                    month = ((leadingZero == true) ? '05' : 5);
                    break;
                case 'Jun':
                    month = ((leadingZero == true) ? '06' : 6);
                    break;
                case 'Jul':
                    month = ((leadingZero == true) ? '07' : 7);
                    break;
                case 'Aug':
                    month = ((leadingZero == true) ? '08' : 8);
                    break;
                case 'Sep':
                    month = ((leadingZero == true) ? '09' : 9);
                    break;
                case 'Oct':
                    month = ((leadingZero == true) ? '10' : 10);
                    break;
                case 'Nov':
                    month = ((leadingZero == true) ? '11' : 11);
                    break;
                case 'Dec':
                    month = ((leadingZero == true) ? '12' : 12);
                    break;
            }

            return month;
        },
        setCurrentMeeting(value) {
            this.currentMeeting = value;

            if(typeof this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[this.currentMeeting] == 'undefined') {
                return false;
            }
            
            let eventID = this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[this.currentMeeting].events[0].ID;

            this.setCurrentEvent(eventID);
        },
        setCurrentEvent(value) {
            eventBus.$emit('loading', ['Results', true]);

            var _self = this;

            // Add leading 0 to relevant days
            let day = this.currentDay;
            if(day < 10) {
                day = '0' + day;
            }

            let date = day + '/' + this.getNumericalMonth(true) + '/' + this.currentYear;
            let cacheDate = this.currentYear + '-' + this.getNumericalMonth(true) + '-' + day;
            let sport = this.formatSport(this.currentSport, false);
            
            this.$API.GetResultEvent(date, cacheDate, sport, value, (response) => {
                let res = response.result;

                if(response.status == 0 || res.errors) {
                    console.error(res.errors);
                    eventBus.$emit('loading', ['Results', false]);
                    return;
                }

                let eachWay = this.getEachWay(res.EWReduction, res.EWPlaceTerms);

                var tmp = {
                    'ID'         : res.ID,
                    'name'       : res.name,
                    'category'   : _self.currentSport,
                    'meetingID'  : res.meetingID.replace('.10', ''),
                    'meetingName': res.meetingName,
                    'startTime'  : res.startTime,
                    'eachWay'    : eachWay,
                    'forecast'   : res.forecast,
                    'tricast'    : res.tricast,
                    'selections' : []
                };

                let selections = res.selections;

                selections.forEach((selection) => {
                    let tmpSel = {
                        'position': selection.position,
                        'number'  : selection.number,
                        'name'    : selection.name,
                        'jockey'  : selection.jockey,
                        'silks'   : selection.silks,
                        'price'   : selection.price
                    };

                    tmp['selections'].push(tmpSel);
                });

                tmp.selections.sort(this.compareSelections);

                var found = false;

                this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[tmp.meetingID].events.forEach((event, index) => {
                    if(event.ID == tmp.ID) {
                        this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[tmp.meetingID].events[index] = tmp;
                        found = true;
                    }
                });

                if(found == false) {
                    this.currentResults[this.getCurrentDateString()].categories[this.currentSport].events[tmp.meetingID].events.push(tmp);
                }

                this.currentEvent = value;
                this.noEvents();
                this.setCurrentEventData();

                eventBus.$emit('loading', ['Results', false]);
            });
        }
    }
}
</script>

<style lang="less">
.results-container {
    width:100%;

    .results-header {
        background-color: #808080;
        border: 2px solid darken(#808080, 10%);
        border-radius: 5px;
        margin-bottom: 15px;
        padding: 5px 10px;

        h1 {
            font-family: 'Staatliches', 'Open Sans', sans-serif;
            font-weight: bold;
            font-size: 32px;
            text-transform: uppercase;
            color: #F9D71E;
        }
    }

    .options-container {
        background-color: #808080;
        border: 2px solid darken(#808080, 10%);
        border-radius: 5px;
        margin-bottom: 15px;
        padding: 5px 10px 10px;

        .control {
            &:not(:last-child) {
                margin-bottom: 10px;
            }
            
            p {
                color: #fff;
            }

            .select {
                margin-top: 10px;
                &:not(.is-multiple):not(.is-loading)::after {
                    border: none;
                }

                .select-wrapper {
                    display: inline-block;
                    position: relative;

                    &::after {
                        border: 3px solid #363636;
                        border-radius: 2px;
                        border-right: 0;
                        border-top: 0;
                        content: " ";
                        display: block;
                        height: 0.625em;
                        margin-top: -0.4375em;
                        pointer-events: none;
                        position: absolute;
                        top: 50%;
                        -webkit-transform: rotate(-45deg);
                        transform: rotate(-45deg);
                        -webkit-transform-origin: center;
                        transform-origin: center;
                        width: 0.625em;
                        right: 0.5em;
                        z-index: 4;
                    }
                }
            }
        }
    }

    .event-container {
        width: 100%;
        margin-bottom: 15px;

        .event-header {
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            padding: 5px 10px;
            background-color: #808080;
            border: 2px solid darken(#808080, 10%);
            border-bottom: 0;

            h2 {
                font-family: 'Staatliches', 'Open Sans', sans-serif;
                font-size: 24px;
                text-transform: uppercase;
                color: #F9D71E;
            }
            .event-start-time {
                float: right;
            }
            .event-start-time,
            p {
                color: #fff;
                font-size: 14px;
                padding-bottom: 4px;
            }
        }

        .event-body {
            width: 100%;
            border: 2px solid darken(#808080, 10%);
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
            border-top: 0;
            overflow: hidden;

            &.no-data {
                padding: 5px 10px;
                background-color: #fff;
                color: #363636;
                border-top: 2px solid darken(#808080, 10%);
                border-radius: 6px;
            }

            table {
                table-layout: fixed;
                width: 100%;

                thead tr {
                    th:first-child {
                        width: 10%;
                        text-align: center;
                    }
                    th:nth-child(2) {
                        width: 10%;
                        text-align: center;
                    }
                    th:nth-child(3) {
                        width: 60%;
                    }
                    th:last-child {
                        width: 20%;
                    }
                }

                .selection-position {
                    text-align: center;
                    vertical-align: middle;
                    font-weight: bold;
                }

                .selection-number {
                    text-align: center;
                    vertical-align: middle;
                    font-weight: bold;
                }

                .selection-name-details {
                    .selection-name,
                    .selection-details {
                        display: block;
                    }

                    .selection-name {
                        word-wrap: break-word;
                    }

                    .selection-colour {
                        height:24px;
                    }
                }

                .price {
                    vertical-align: middle;

                    span {
                        display: inline-block;
                        text-align: center;
                        font-size: 15px;
                        font-weight: bold;
                        padding: 4px 6px;
                        background-color: #8b0000;
                        border: 2px solid darken(#8b0000, 20%);
                        color: #fff;
                        min-width: 62px;
                        letter-spacing: 0.05em;
                    }
                }
            }
        }
    }
}
@media (max-width: 1080px) {
    .results-container .results-tables table {
        thead tr {
            th:first-child {
                width: 15% !important;
            }
            th:nth-child(2) {
                width: 15% !important;
            }
            th:last-child {
                width: 70% !important;
            }
        }
    }
}
@media (max-width: 700px) {
    .results-container {
        .results-header {
            margin-bottom: 10px;
        }

        .event-container {
            &:last-child {
                margin-bottom: 0;
            }
            &:not(:last-child) {
                margin-bottom: 10px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Results.vue